import { STATIC_SESSION } from '../session';
export const DEFAULT_ACCOUNT = {
    companies_trial_auto_upgrade: false,
    companies_trial_end_date: null,
    companies_trial_start_date: null,
    company_account_end_date: null,
    company_address: null,
    company_initial_engagement: false,
    created_at: '',
    currency: '',
    first_known_upgrade_date: '',
    has_been_in_companies_trial: false,
    has_modern_pricing_plan: false,
    id: null,
    is_chat_eligible: false,
    is_company_account: false,
    is_in_experts_mvp: false,
    is_premier_chat_eligible: false,
    is_team_account: false,
    is_trialing_companies: false,
    is_trialing_teams: false,
    is_trialing: false,
    is_unlimited: false,
    last_plan_change_at: '',
    logo_url: '',
    name: '',
    offer_returning_trial_extension: false,
    owner: { id: null, name: '', email: '' },
    paying: false,
    pays_manually: false,
    period_end: '',
    period_start: '',
    plan_group_id: null,
    plan_info: {
        id: null,
        name: '',
        metered_task_pricing: false,
        interval: '',
        allow_companies: false,
        allow_teams: false,
        allow_import_export: false,
    },
    surveys_submitted: {
        company_trial_onboarding: false,
        company_trial_exit: false,
    },
    team_account_end_date: null,
    teams_trial_auto_upgrade: false,
    teams_trial_end_date: null,
    trial_auto_upgrade: false,
    trial_end_date: null,
    is_loading: false,
};
export const STATIC_ACCOUNT = {
    companies_trial_auto_upgrade: false,
    companies_trial_end_date: null,
    companies_trial_start_date: null,
    company_account_end_date: null,
    company_address: null,
    company_initial_engagement: true,
    created_at: '2017-03-14T18:29:35Z',
    currency: 'USD',
    first_known_upgrade_date: '2017-03-14 18:29:40+00:00',
    has_been_in_companies_trial: false,
    has_modern_pricing_plan: false,
    id: 2074697,
    is_chat_eligible: false,
    is_company_account: true,
    is_in_experts_mvp: false,
    is_premier_chat_eligible: true,
    is_team_account: true,
    is_trialing_companies: false,
    is_trialing_teams: false,
    is_trialing: false,
    is_unlimited: true,
    last_plan_change_at: '2021-01-20T23:27:52Z',
    logo_url: 'https://cdn.zappy.app/ef609ad5f25ec5a10ffb86d64a927aa7.png',
    name: 'Zapier',
    offer_returning_trial_extension: false,
    owner: { id: 8121946, name: 'Chief Bogo', email: 'chief.bogo@zootopia.org' },
    paying: true,
    pays_manually: false,
    period_end: '2022-11-30T23:27:49.124248Z',
    period_start: '2022-10-30T23:27:49.124248Z',
    plan_group_id: 53,
    plan_info: {
        id: 322,
        name: 'Company',
        metered_task_pricing: true,
        interval: 'month',
        allow_companies: true,
        allow_teams: true,
        allow_import_export: true,
    },
    surveys_submitted: {
        company_trial_onboarding: false,
        company_trial_exit: false,
    },
    team_account_end_date: null,
    teams_trial_auto_upgrade: true,
    teams_trial_end_date: null,
    trial_auto_upgrade: false,
    trial_end_date: null,
    is_loading: false,
};
export const STATIC_ACCOUNTS = [
    STATIC_ACCOUNT,
    Object.assign(Object.assign({}, STATIC_ACCOUNT), { id: 9122541, paying: false, name: 'Personal Account', logo_url: 'https://cdn.zapier.com/zapier/images/account-default-image.svg', owner: {
            id: STATIC_SESSION.id,
            name: `${STATIC_SESSION.first_name} ${STATIC_SESSION.last_name}`,
            email: STATIC_SESSION.email,
        }, plan_info: {
            id: 640,
            name: 'Free',
            metered_task_pricing: false,
            interval: 'month',
            allow_companies: false,
            allow_teams: false,
            allow_import_export: false,
        } }),
];
//# sourceMappingURL=constants.js.map